import { Text, UnstyledButton } from '@mantine/core';
import { useNavigate } from 'react-router';

import { brand } from '../../branding';
import { useCatalogLabels } from '../labels';
import { HEADER_OVERLAY_ROW_HEIGHT, HEADER_OVERLAY_TOP_CSS, HEADER_OVERLAY_Z_INDEX, leftInset } from './headerLayout';

// The yellow DOKA header bar (logo, avatar) is rendered by the private @uag/react-core
// BaseLayout/portal chrome, not by our own code - there's no prop to inject content next to the
// logo. LanguageSwitch already overlays its language select into that same bar via a
// `position: fixed` element sized/positioned to match it; this does the same for the app title.
// Text colour follows the configured brand (see branding.ts), since a non-DOKA brand paints that
// bar in its own colour (BrandHeaderBar) and DOKA blue would not necessarily read on it.
//
// LEFT is a best-effort pixel offset meant to sit right of the DOKA logo with some breathing room
// - this sandbox has no access to the private @uag packages to preview the real header, so nudge
// this value after checking the rendered result if it doesn't line up.
const LEFT_OFFSET = 250;

export const HeaderBrand = () => {
    const { L } = useCatalogLabels();
    const navigate = useNavigate();

    return (
        <UnstyledButton
            // Hidden below `md` - the offset above is tuned for desktop widths and collides with
            // the other header overlays once the yellow bar's logo shrinks on mobile (see chat
            // screenshots). MobileHeaderBar renders the title in normal flow below the yellow bar
            // instead.
            className="hidden items-center md:flex"
            style={{
                position: 'fixed',
                top: HEADER_OVERLAY_TOP_CSS,
                left: leftInset(LEFT_OFFSET),
                height: HEADER_OVERLAY_ROW_HEIGHT,
                zIndex: HEADER_OVERLAY_Z_INDEX,
            }}
            onClick={() => navigate('/')}
        >
            <Text c={brand.headerForeground} fw={700} size="xl">
                {L.title}
            </Text>
        </UnstyledButton>
    );
};
